export default "__VITE_ASSET__BGQO0bds__"